// plugins/logout.client.ts
import { defineNuxtPlugin } from "#app";
import { useUserStore } from "~/stores/userstore";
import { useRouter } from "vue-router";
import axios from "axios";

export default defineNuxtPlugin((nuxtApp) => {
  console.debug("logout.client.ts loaded");
  const userStore = useUserStore();
  const router = useRouter();

  nuxtApp.provide("logout", async () => {
    // Remove local token
    userStore.clearAuth();

    try {
      //@ts-expect-error Url is globally defined and loaded in head - /service/api/js/urls
      await Promise.all([axios.get(Url.Users_Jwt_Guest_Create)]);
    } catch (error) {
      console.error("Logout error", error);
    } finally {
      localStorage.setItem(
        "errorAfterReload",
        JSON.stringify({
          message:
            "You have been automatically logged out, please log in again.",
          type: "success",
          logInOption: true,
        }),
      );

      console.debug("Logout - redirect to home");
      await router.push("/");
    }
  });
});
